import { CommonAPIService } from 'src/servicehandlers/CommonHandler';

export class EmailAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  getByName(name, router) {
    const url = `/api/email/${name}`;
    return this.CommonAPIService.getCall(url, '', router);
  }

  upsert(params, router) {
    const url = '/api/email';
    return this.CommonAPIService.putCall(url, params, router);
  }

}
export default EmailAPIService;
